export default "__VITE_PUBLIC_ASSET__88eaccdb__"